<template>
<div class="default-container p-3">
    <filtro
        :showfiltro="showFiltro"
        :params="paramsFiltro"
        @change="filtroChange"
        @cancel="handleCloseFiltro"
      />
    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
        <span class="lbl-deal-title mb-2 w-100">Consulta Resumo Movimentação de Estoque </span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar()"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-end">
        <div class="col-md-5">
            <v-label label="Período"></v-label>
            <input-month2 :p-month="periodo"></input-month2>
        </div>
        <div class="col-md-4">
            <input-search
                label="Pesquisar item"
                v-model="itemPesquisa"
                entity="item"
                @change="handleItemSelect"
            />
        </div>
        <div class="col-md-2 mb-1">
            <v-button icon="fa-search" :success="true" @click="loadData(false, false)"></v-button>
            <v-button icon="fa-filter" class="ml-1" @click="handleShowFiltro"></v-button>
        </div>
    </div>
    <hr>
    <div class="row mb-5">
        <div class="col-12 lbl-deal-title mb-2" >
            <span>RESUMO MOVIMENTAÇÕES</span>
            <v-button label="Exel" class="float-right" @click="loadData(true)"></v-button>
        </div>
        <div class="col-12" style="font-size: 12px">
            <div style="overflow:auto">
                <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100" >
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="" title="">Código<i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="textual header" style="width:30%" title="">Descrição<i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="textual header" style="" title="">Uni<i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="" title=""> Estoque Atual <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="" title=""> Entradas no Período <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="" title=""> Saidas no Período <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="textual header" style="width:8%" title=""> Dt ultima Entada <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="textual header" style="width:8%" title=""> Dt ultima saida <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="width:8%" title=""> Dias sem vender <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="height: 37px" v-for="(row, index) in dados.items" :key="index">
                                <td class="textual">{{ row.codigo }}</td>
                                <td class="textual">
                                    <span>{{ row.descricao }}</span>
                                    <span v-if="row.linha || row.coluna"><strong> ({{row.linha}} / {{row.coluna}})</strong></span>
                                </td>
                                <td class="textual">{{ row.uni }}</td>
                                <td class="numerico" title=""> {{ row.saldo | formatValue(2,true) }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></td>
                                <td class="numerico" title=""> {{ row.qtentradas | formatValue(2,true) }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></td>
                                <td class="numerico" title=""> {{ row.qtsaidas | formatValue(2,true) }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></td>
                                <td class="textual">{{ row.dtultentrada | formatData}}</td>
                                <td class="textual">{{ row.dtultsaida | formatData}}</td>
                                <td class="numerico" title=""> {{ row.dias_sem_vender }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>


</div>

</template>

<script>
import DashCard from '../dashboards/dash-card'
import Chart from './chart'
import Filtro from './filtro'
import { SysVars } from '../main'
import { apiORDSpost } from '../shared/api-functions'
import { apiDownload2 } from '../shared/api-functions'

export default {
    components: {
        DashCard, Filtro, Chart
    },
    data () {
        return {
            showFiltro: false,
            dados : {},
            itemPesquisa: '',
            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },
            paramsFiltro: {
                checkbox:[
                    {nome:'com_estoque', label: 'Somente Produtos com Estoque', valueChecked: true, valueUnchecked: false, value: false},
                    {nome:'sem_circulacao', label: 'Somente Produtos sem circulação', valueChecked: true, valueUnchecked: false, value: false}
                ],
                filtros: [
                    { nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] },
                ],
            },
            filtro:{
                periodos:[
                    { data_inicio: null, data_termino: null}
                ]
            },
            nextPage: false
        }
    },
     watch: {
        itemPesquisa: function(newVal) {
            if (!newVal) {
                delete this.filtro.produto;
                delete this.filtro.descricao;
            } else {
                // Delay to allow handleItemSelect to process first if an item was clicked
                setTimeout(() => {
                    if (!this.filtro.produto || String(this.filtro.produto[0]) !== String(newVal)) {
                        delete this.filtro.produto;
                        this.filtro.descricao = newVal;
                    }
                }, 100);
            }
        },
    },
    computed:{
    },
    methods:{
        handleItemSelect(item) {
            if (item && (item.id || item.codigo)) {
                this.filtro.produto = [item.id || item.codigo];
                delete this.filtro.descricao;
            }
        },
        handleCloseFiltro(){
            this.showFiltro = false
        },
        handleCancel(){
            this.showFiltro = false
        },
        filtroChange(filtro){
            if (this.filtro.produto) filtro.produto = this.filtro.produto;
            if (this.filtro.descricao) filtro.descricao = this.filtro.descricao;

            this.filtro = filtro;
            this.loadData();
            this.showFiltro = false
        },
        clickRetornar () {
            this.$router.push('/')
        },
        handleShowFiltro(){
            this.showFiltro = true
        },
        scroll () {
          window.onscroll = () => {
            if (this.nextPage) return;

            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 50

            if (bottomOfWindow && this.dados.has_more) {
              this.loadData(false, true)
            }
            SysVars.scrollPosition = document.documentElement.scrollTop
          }
        },

        async loadData(excel, loadMore) {

           let url = "consulta/estoque/resumomovimentacaoestoque";
           // let url = "consulta/teste";

           this.periodo.data_inicio = this.periodo.startDate;
           this.periodo.data_termino = this.periodo.endDate;
           this.filtro.periodos = [ this.periodo ];
           this.filtro.data_inicio = this.periodo.startDate;
           this.filtro.data_termino = this.periodo.endDate;

           console.log(this.filtro)

           if (loadMore) {
             if (this.dados.has_more) {
               this.filtro.page = this.dados.next_page
               this.nextPage = true
             }
             else {
               return
             }
           } else {
             delete this.filtro.page
           }

           this.filtro.excel = excel

           if (excel)
             apiDownload2(this, url, this.filtro, "post")
           else {
             const data = await apiORDSpost(this.$store, url, this.filtro, "post")
             if (data) {
               if (loadMore) {
                 this.dados.items.push(...data.items)
                 this.dados.has_more = data.has_more
                 this.dados.next_page = data.next_page
               }
               else
                 this.dados = data
             } else {
               if (!loadMore) this.dados = {};
             }
           }

           let self = this
           this.$nextTick(function () {
             self.nextPage = false
           })

        },

    },

    created(){
      this.periodo.data_inicio = this.$firstDay(this.$getDate());
      this.periodo.data_termino = this.$lastDay(this.$getDate());
      this.periodo.startDate = this.$firstDay(this.$getDate());
      this.periodo.endDate = this.$lastDay(this.$getDate());
    },

    mounted() {
      this.scroll()
    },

    destroyed () {
      window.onscroll = null
    },


}

</script>

<style>

table .numerico {
    min-width:65px;
    text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/consultas/consulta-resumo-movimento-estoque.vue